
<form id="contact-information" [formGroup]="regForm" (ngSubmit)="step2Submitted(regForm)" novalidate>



  <div class="form-row">
    <label style="font-weight: bold; font-size: x-large;">{{'Step3-Contact.TranslationSection.text1' | translate}}</label>
  
  </div><br><br>
  

          
    <div>

    <div class="form-row">
      <div class="form-group col-lg-4 col-sm-4 col-md-4" >
        <label >{{'Step3-Contact.TranslationSection.text2' | translate}}</label>
        <input type="text" class="form-control" for="fname" formControlName="firstName" id="fname"  [ngClass]="{'form-submitted': isSubmitted}" readonly>
      </div>
      <div class="form-group col-lg-4 col-sm-4 col-md-4" >
        <label>{{'Step3-Contact.TranslationSection.text3' | translate}}</label>
        <input type="text" class="form-control" for="lname"  formControlName="lastName" id="lname"  [ngClass]="{'form-submitted': isSubmitted}" readonly>
      </div>

      <div class="form-group  col-lg-4 col-sm-4 col-md-4" >
        <label>{{'Step3-Contact.TranslationSection.text4' | translate}}</label>
        <input type="text" class="form-control" for="email"  formControlName="email" id="email"  [ngClass]="{'form-submitted': isSubmitted}" readonly>
      </div>

    </div>

    <div class="form-row">
    <div class="form-group  col-lg-3 col-sm-3 col-md-3" >
      <label>{{'Step3-Contact.TranslationSection.text5' | translate}}</label>
      <input type="text" class="form-control" for="add1" formControlName="address" id="add1"  [ngClass]="{'form-submitted': isSubmitted}">
    </div>
 

    <div class="form-group  col-lg-3 col-sm-3 col-md-3" >
      <label>{{'Step3-Contact.TranslationSection.text6' | translate}}</label>
      <input type="text" class="form-control" for="cty" formControlName="city" id="cty" [ngClass]="{'form-submitted': isSubmitted}">
    </div>
    <div class="form-group  col-lg-3 col-sm-3 col-md-3" >
      <label>{{'Step3-Contact.TranslationSection.text7' | translate}}</label>
      <select id="stat" class="form-control" for="stat" formControlName="state" [ngClass]="{'form-submitted': isSubmitted}">
        <option [selected]="1==1">{{'Step3-Contact.TranslationSection.text8' | translate}}</option>
        <option *ngFor="let state of states" [ngValue]="state.abbreviation">{{state.name}}</option>
      </select>
    </div>
    <div class="form-group  col-lg-3 col-sm-3 col-md-3" >
      <label>{{'Step3-Contact.TranslationSection.text9' | translate}}</label>
      <input type="text" class="form-control" for="zp"  formControlName="zip" id="zp" [ngClass]="{'form-submitted': isSubmitted}">
    </div>



  </div>

  
  <div class="form-row" style="height:20px;"></div>





  <div class="form-row">

    <div class="form-group col-md-6 col-sm-6 col-lg-6" style="text-align:left;">

      <label><b>{{'Step3-Contact.TranslationSection.text10' | translate}}</b>:</label>

    </div>


    <div class="form-group col-md-4  col-sm-4 col-lg-4" style="text-align:center;">
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio"  id="pa" formControlName="pstname" value="Yes" (click)="pastNameClick('Yes')">
          <label class="form-check-label" for="yes">{{'Step3-Contact.TranslationSection.text11' | translate}}</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio"  id="cons" formControlName="pstname" value="No" (click)="pastNameClick('No')">
          <label class="form-check-label" for="yes">{{'Step3-Contact.TranslationSection.text12' | translate}}</label>
        </div>

        <div style="color: red;" *ngIf="isSubmitted && this.regForm.get('pstname').invalid">
          ***required field***
      </div>
    </div>

   

  </div>





  <div class="form-row">

    <div class="form-group  col-lg-4 col-sm-4 col-md-4" style="text-align: left;">

      <label>{{'Step3-Contact.TranslationSection.text13' | translate}}</label>

    </div>



    <div class="form-group  col-lg-4 col-sm-4  col-md-4" >
      <select id="ntype1" class="form-control" for="pastname1" formControlName="pastname1" [ngClass]="{'form-submitted': isSubmitted}" >
       <!-- <option [selected]="1==1">Please Choose...</option>-->
        <option *ngFor="let nametype of nametypes" [ngValue]="nametype.value">{{nametype.name}}</option>
      </select>
    </div>

    <div class="form-group  col-lg-4 col-sm-4 col-md-4" >

      <input type="text" class="form-control" for="txtpastname1" formControlName="txtpastname1" id="txtpastname1" [ngClass]="{'form-submitted': isSubmitted}"  placeholder="{{'Step3-Contact.TranslationSection.text14' | translate}}">
    </div>

  </div>



  <div class="form-row">

    
    <div class="form-group  col-lg-4 col-sm-4 col-md-4" ></div>

    <div class="form-group  col-lg-4 col-sm-4 col-md-4" >
      <select id="ntype2" class="form-control" for="pastname2" formControlName="pastname2" [ngClass]="{'form-submitted': isSubmitted}">
           <!-- <option [selected]="1==1">Please Choose...</option>-->
        <option *ngFor="let nametype of nametypes" [ngValue]="nametype.value">{{nametype.name}}</option>
      </select>
    </div>

    <div class="form-group  col-lg-4 col-sm-4 col-md-4" >

      <input type="text" class="form-control" for="txtpastname2" formControlName="txtpastname2" id="txtpastname2" [ngClass]="{'form-submitted': isSubmitted}"  placeholder="{{'Step3-Contact.TranslationSection.text15' | translate}}">
    </div>

  </div>





  <div class="form-row">

    <div class="form-group  col-lg-4 col-sm-4 col-md-4" ></div>


    <div class="form-group  col-lg-4 col-sm-4 col-md-4" >
      <select id="ntype3" class="form-control" for="pastname3" formControlName="pastname3" [ngClass]="{'form-submitted': isSubmitted}">
           <!-- <option [selected]="1==1">Please Choose...</option>-->
        <option *ngFor="let nametype of nametypes" [ngValue]="nametype.value">{{nametype.name}}</option>
      </select>
    </div>

    <div class="form-group col-lg-4 col-sm-4 col-md-4" >

      <input type="text" class="form-control" for="txtpastname3" formControlName="txtpastname3" id="txtpastname3" [ngClass]="{'form-submitted': isSubmitted}"  placeholder="{{'Step3-Contact.TranslationSection.text16' | translate}}">
    </div>

  </div>





  



  <div class="form-row">

    <div class="form-group col-md-6 col-sm-6 col-lg-6" style="text-align: left;">

      <label><b>{{'Step3-Contact.TranslationSection.text17' | translate}} </b>:</label>

    </div>


    <div class="form-group col-md-4 col-sm-4 col-lg-4" style="text-align: center;" >
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio"  id="pstaddress" formControlName="pstaddress" value="Yes"  (click)="pastAddressClick('Yes')">
          <label class="form-check-label" for="yes">{{'Step3-Contact.TranslationSection.text18' | translate}}</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio"  id="pstaddress" formControlName="pstaddress" value="No"  (click)="pastAddressClick('No')">
          <label class="form-check-label" for="no">{{'Step3-Contact.TranslationSection.text19' | translate}}</label>
        </div>

        <div style="color: red;" *ngIf="isSubmitted && this.regForm.get('pstaddress').invalid">
          ***required field***
      </div>
    </div>



  </div>





  <div class="form-row">

    <div class="form-group col-lg-4 col-sm-4 col-md-4" style="text-align: left;">

      <label>{{'Step3-Contact.TranslationSection.text20' | translate}}</label>

    </div>

    <div class="form-group col-lg-4 col-sm-4 col-md-4" >
  
      <input type="text" class="form-control" for="txtpastaddress1" formControlName="txtpastaddress1" id="txtpastaddress1" [ngClass]="{'form-submitted': isSubmitted}" placeholder="{{'Step3-Contact.TranslationSection.text21' | translate}}">
    </div>

    <div class="form-group col-lg-4 col-sm-4 col-md-4" >

      <input type="text" class="form-control" for="txtpastaddressdate1" formControlName="txtpastaddressdate1" id="txtpastaddressdate1" [ngClass]="{'form-submitted': isSubmitted}" placeholder="{{'Step3-Contact.TranslationSection.text22' | translate}}">
    </div>



  </div>



  <div class="form-row">

    <div class="form-group  col-lg-4 col-sm-4 col-md-4" ></div>

    <div class="form-group col-lg-4 col-sm-4 col-md-4" >
       
      <input type="text" class="form-control" for="txtpastaddress2" formControlName="txtpastaddress2" id="txtpastaddress2" [ngClass]="{'form-submitted': isSubmitted}" placeholder="{{'Step3-Contact.TranslationSection.text23' | translate}}">
        </div>
    
        <div class="form-group col-lg-4 col-sm-4 col-md-4" >
    
          <input type="text" class="form-control" for="txtpastaddressdate2" formControlName="txtpastaddressdate2" id="txtpastaddressdate2" [ngClass]="{'form-submitted': isSubmitted}" placeholder="{{'Step3-Contact.TranslationSection.text24' | translate}}">
        </div>



  </div>




  <div class="form-row">

    <div class="form-group  col-lg-4 col-sm-4 col-md-4" ></div>

    <div class="form-group col-lg-4 col-sm-4 col-md-4" >
         
      <input type="text" class="form-control" for="txtpastaddress3" formControlName="txtpastaddress3" id="txtpastaddress3" [ngClass]="{'form-submitted': isSubmitted}" placeholder="{{'Step3-Contact.TranslationSection.text25' | translate}}">
        </div>
    
        <div class="form-group col-lg-4 col-sm-4 col-md-4" >
    
          <input type="text" class="form-control" for="txtpastaddressdate3" formControlName="txtpastaddressdate3" id="txtpastaddressdate3" [ngClass]="{'form-submitted': isSubmitted}" placeholder="{{'Step3-Contact.TranslationSection.text26' | translate}}">
        </div>


  </div>



  </div>



<br>



<button type="button" (click) = "decreasePage()" class="btn btn-create"  matStepperPrevious><i className="ace-icon fa fa-arrow-left"></i>{{'Step3-Contact.TranslationSection.text27' | translate}}</button>
&nbsp;
<button type="submit"  class="btn btn-primary" >{{'Step3-Contact.TranslationSection.text28' | translate}} &nbsp;
<i className="ace-icon fa fa-arrow-right icon-on-right"></i></button>   


<div class="spinner-border text-success" role="status" style="position: absolute; bottom:10;" *ngIf="isfetching === true"></div>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i className="fa fa-spinner fa-spin  fa-2x" style="color:blue" *ngIf="isfetching === true"> {{'Step3-Contact.TranslationSection.text29' | translate}}</i>


  </form>


  
  
  
  
  
  
  